// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { createContext } from 'react';
const ListOperationContext = /*#__PURE__*/createContext({
  selectedRows: 0
});
ListOperationContext.displayName = 'ListOperationContext';
export default ListOperationContext;